import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { PermissionService } from '../../core/services/user/permission.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appHasClaim]',
  standalone: true,
})
export class HasClaimDirective implements OnInit, OnDestroy {
  private _claims: string | string[] = [];
  private subscription: Subscription = new Subscription();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.permissionService.permissionsChanged$.subscribe(() => {
        this.updateView();
      })
    );
    this.updateView();
  }

  @Input()
  set appHasClaim(value: string | string[]) {
    this._claims = value;
    this.updateView();
  }

  private updateView() {
    let hasPermission = false;
    if (Array.isArray(this._claims)) {
      hasPermission = this.permissionService.hasAnyPermission(this._claims);
    } else {
      hasPermission = this.permissionService.hasPermission(this._claims);
    }

    if (hasPermission) {
      if (this.viewContainer.length === 0) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainer.clear();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
